import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_USERS = restRequest(
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.GET_USERS"
);
export const SET_PAGE = "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_PAGE";
export const SET_PROFILE = "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_PROFILE";
export const SET_ROWS = "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_ROWS";
export const REMOVE_USER = restRequest(
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.REMOVE_USER"
);
export const SET_USER_TYPE_FILTER =
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_USER_TYPE_FILTER";
export const REMOVE_CREW_USER = restRequest(
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.REMOVE_CREW_USER"
);
export const GET_DEPARTMENTS = restRequest(
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.GET_DEPARTMENTS"
);
export const GET_AREAS = restRequest(
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.GET_AREAS"
);
export const SET_FILTER_DEPARTMENT_NAME =
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_FILTER_DEPARTMENT_NAME";
export const SET_FILTER_AREA_NAME =
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_FILTER_AREA_NAME";
export const SET_LAST_ACTIVE =
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_LAST_ACTIVE";
export const SET_USER_FILTER =
    "VR_CORE.USER_MANAGER_TABLE_DATA_WIDGET.SET_USER_FILTER";

export const SET_NEW_USER = restRequest(
    "VRCORE.UMV4_ADD_USER_WIDGET.SET_NEW_USER"
);
